import styled from 'styled-components';

export const ToggleSwitchCheckbox = styled.input`
  display: none;
`;

export const ToggleSwitchLabel = styled.label`
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
  margin: 0;

  &:focus {
    outline: none;
  }
  & > span:focus {
    outline: none;
  }
`;

export const ToggleSwitchInner = styled.span`
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;

  &:before,
  &:after {
    display: block;
    float: left;
    width: 50%;
    height: 20px;
    padding: 0;
    line-height: 20px;
    font-size: 10px;
    font-weight: bold;
    box-sizing: border-box;
  }

  &:before {
    content: attr(data-yes);
    text-transform: uppercase;
    padding-left: 5px;
    background-color: ${(props) =>
      props.switchColor ? props.switchColor : props.theme.colors.REWARDS.PLCC};
    color: #fff;
  }

  &:after {
    content: attr(data-no);
    text-transform: uppercase;
    padding-right: 3px;
    background-color: ${(props) => (props.offColor ? props.offColor : '#fff')};
    border: 1px solid ${(props) => (props.offColor ? props.offColor : '#979797')};
    border-radius: 20px;
    color: #000;
    text-align: right;
  }
`;

export const ToggleSwitchSwitch = styled.span`
  display: block;
  width: 14px;
  height: 14px;
  margin: 3px;
  background: ${(props) =>
    props.toggleSwitchSwitchColor ? props.toggleSwitchSwitchColor : '#000'};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 25px;
  border: 0 solid #bbb;
  border-radius: 20px;
  transition: all 0.3s ease-in 0s;
`;

export const ToggleSwitchWrapper = styled.div`
  position: relative;
  width: 45px;
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  text-align: left;

  .toggle-switch-disabled {
    background-color: #ddd;
    cursor: not-allowed;
    opacity: 0.5;

    &:before {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }
  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-inner {
    margin-left: 0;
  }
  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-switch {
    right: 0px;
    background: #fff;
  }
`;
